export default __webpack_public_path__ + "./images/discount.8f75322b.svg";